import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import CompanyApi from "../../api/repositories/companies";
import {handleApiError} from "../../helpers/handleApiError";
import {getDashboard} from "./dashboard";
import {setKybStatus, setLogo} from "./kyb";

const initialState = {
  isLoading: false,
};

export const createCompany = createAsyncThunk(
    "company/createCompany",
    async (payload, { dispatch }) => {
      try {
        const response = await CompanyApi.create_company(payload);

        dispatch(getDashboard());
        dispatch(setKybStatus())

        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);

export const removeCompany = createAsyncThunk(
  "company/removeCompany",
  async (_, { dispatch }) => {
    try {
      const response = await CompanyApi.remove_company();
      
      dispatch(getDashboard());
      dispatch(setKybStatus());

      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error; // Важно пробросить ошибку дальше
    }
  }
);
export const changeCompany = createAsyncThunk(
    "company/changeCompany",
    async (payload, { dispatch }) => {
      try {
        const response = await CompanyApi.change_company(payload);

        dispatch(getDashboard());
        dispatch(setLogo(""));

        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(changeCompany.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(changeCompany.fulfilled, (state) => {
          state.isLoading = false;
        })
    builder
        .addCase(removeCompany.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(removeCompany.fulfilled, (state) => {
          state.isLoading = false
        });
    builder
        .addCase(createCompany.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(createCompany.fulfilled, (state) => {
          state.isLoading = false
        });
  },
});

export default companySlice.reducer;